import React, { useState } from "react";
import { colors, fonts } from "../utils/constants.js";
import { isMobile, getButtonStyle, getTypographyStyle } from "../utils/responsive.js";

function WelcomeOverlay({ onClose, onSignUp }) {
  const [currentStep, setCurrentStep] = useState(0);
  const [isMobileDevice, setIsMobileDevice] = useState(false);

  React.useEffect(() => {
    const checkIsMobile = () => setIsMobileDevice(isMobile());
    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);
    return () => window.removeEventListener('resize', checkIsMobile);
  }, []);

  const steps = [
    {
      title: "Добре дошли в BGPoll! 🇧🇬",
      subtitle: "Платформата за прогнози на българската общественост",
      content: (
        <div style={{ textAlign: "center", lineHeight: 1.6 }}>
          <p style={{ margin: "0 0 16px 0", color: colors.text }}>
            Гласувайте по актуални въпроси и видете какво мисли България.
          </p>
          <p style={{ margin: "0", color: colors.textSec }}>
            Всеки глас има значение в създаването на по-информирано общество.
          </p>
        </div>
      ),
    },
    {
      title: "Как работи? 📊",
      subtitle: "Три лесни стъпки до участие",
      content: (
        <div style={{ textAlign: "left" }}>
          <div style={{ display: "flex", alignItems: "center", marginBottom: 16 }}>
            <div
              style={{
                width: 32,
                height: 32,
                borderRadius: "50%",
                background: colors.green,
                color: "#FFF",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: "bold",
                marginRight: 12,
                fontSize: 14,
              }}
            >
              1
            </div>
            <span style={{ color: colors.text }}>Прочетете въпроса внимателно</span>
          </div>
          <div style={{ display: "flex", alignItems: "center", marginBottom: 16 }}>
            <div
              style={{
                width: 32,
                height: 32,
                borderRadius: "50%",
                background: colors.blue,
                color: "#FFF",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: "bold",
                marginRight: 12,
                fontSize: 14,
              }}
            >
              2
            </div>
            <span style={{ color: colors.text }}>Изберете "ДА" или "НЕ"</span>
          </div>
          <div style={{ display: "flex", alignItems: "center" }}>
            <div
              style={{
                width: 32,
                height: 32,
                borderRadius: "50%",
                background: colors.red,
                color: "#FFF",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: "bold",
                marginRight: 12,
                fontSize: 14,
              }}
            >
              3
            </div>
            <span style={{ color: colors.text }}>Вижте резултатите в реално време</span>
          </div>
        </div>
      ),
    },
    {
      title: "Започнете сега! 🚀",
      subtitle: "Гласувайте като гост или се регистрирайте за повече функции",
      content: (
        <div style={{ textAlign: "center" }}>
          <div
            style={{
              padding: 16,
              background: colors.blueBg,
              borderRadius: 8,
              border: `1px solid ${colors.blueBorder}`,
              marginBottom: 16,
            }}
          >
            <h4 style={{ margin: "0 0 8px 0", color: colors.blue, fontWeight: 600 }}>
              Като гост: 👤
            </h4>
            <p style={{ margin: 0, fontSize: 14, color: colors.textSec }}>
              Гласувайте веднага без регистрация
            </p>
          </div>
          <div
            style={{
              padding: 16,
              background: colors.greenBg,
              borderRadius: 8,
              border: `1px solid ${colors.greenBorder}`,
            }}
          >
            <h4 style={{ margin: "0 0 8px 0", color: colors.green, fontWeight: 600 }}>
              С акаунт: ⭐
            </h4>
            <p style={{ margin: 0, fontSize: 14, color: colors.textSec }}>
              История на гласуванията, статистики и повече функции
            </p>
          </div>
        </div>
      ),
    },
  ];

  const handleNext = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
    }
  };

  const handlePrev = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleSkip = () => {
    onClose();
  };

  const step = steps[currentStep];

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0, 0, 0, 0.7)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: isMobileDevice ? 16 : 24,
        zIndex: 1000,
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: colors.card,
          borderRadius: 12,
          padding: isMobileDevice ? 20 : 32,
          maxWidth: isMobileDevice ? "calc(100vw - 32px)" : 480,
          width: "100%",
          maxHeight: isMobileDevice ? "90vh" : "auto",
          boxShadow: "0 20px 40px rgba(0, 0, 0, 0.15)",
          border: `1px solid ${colors.border}`,
          overflow: "auto",
          position: "relative",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div style={{ textAlign: "center", marginBottom: 24 }}>
          <h2
            style={{
              ...getTypographyStyle("h2", isMobileDevice),
              margin: "0 0 8px 0",
              color: colors.text,
            }}
          >
            {step.title}
          </h2>
          <p
            style={{
              margin: 0,
              color: colors.textSec,
              fontSize: isMobileDevice ? 16 : 18,
            }}
          >
            {step.subtitle}
          </p>
        </div>

        {/* Progress */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: 24,
            gap: 8,
          }}
        >
          {steps.map((_, index) => (
            <div
              key={index}
              style={{
                width: 8,
                height: 8,
                borderRadius: "50%",
                background: index === currentStep ? colors.green : colors.border,
                transition: "background 0.3s",
              }}
            />
          ))}
        </div>

        {/* Content */}
        <div style={{ marginBottom: 32 }}>{step.content}</div>

        {/* Actions */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 12,
            flexDirection: isMobileDevice ? "column" : "row",
          }}
        >
          {/* Navigation Row */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              gap: 12,
            }}
          >
            {/* Left: Skip or Back */}
            {currentStep > 0 ? (
              <button
                onClick={handlePrev}
                style={{
                  ...getButtonStyle("secondary", "medium", isMobileDevice),
                  background: "transparent",
                  color: colors.textSec,
                  border: `1px solid ${colors.border}`,
                  display: "flex",
                  alignItems: "center",
                  gap: 4,
                }}
              >
                ← Назад
              </button>
            ) : (
              <button
                onClick={handleSkip}
                style={{
                  ...getButtonStyle("secondary", "medium", isMobileDevice),
                  background: "transparent",
                  color: colors.textSec,
                  border: "none",
                  textDecoration: "underline",
                }}
              >
                Пропусни
              </button>
            )}

            {/* Center: Progress indicator for mobile */}
            {isMobileDevice && (
              <span style={{ fontSize: 12, color: colors.textTer }}>
                {currentStep + 1} от {steps.length}
              </span>
            )}

            {/* Right: Next or Action Buttons */}
            {currentStep < steps.length - 1 ? (
              <button
                onClick={handleNext}
                style={{
                  ...getButtonStyle("primary", "medium", isMobileDevice),
                  background: colors.green,
                  color: "#FFF",
                  border: "none",
                  display: "flex",
                  alignItems: "center",
                  gap: 4,
                }}
              >
                Напред →
              </button>
            ) : null}
          </div>

          {/* Final Step Actions */}
          {currentStep === steps.length - 1 && (
            <div 
              style={{ 
                display: "flex", 
                gap: 8, 
                width: "100%",
                justifyContent: "center",
                marginTop: isMobileDevice ? 8 : 0,
              }}
            >
              <button
                onClick={onClose}
                style={{
                  ...getButtonStyle("secondary", "medium", isMobileDevice),
                  background: "transparent",
                  color: colors.blue,
                  border: `1px solid ${colors.blue}`,
                  flex: 1,
                }}
              >
                Гласувай като гост
              </button>
              <button
                onClick={onSignUp}
                style={{
                  ...getButtonStyle("primary", "medium", isMobileDevice),
                  background: colors.green,
                  color: "#FFF",
                  border: "none",
                  flex: 1,
                }}
              >
                Регистрирай се
              </button>
            </div>
          )}
        </div>

        {/* Close button */}
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            top: 16,
            right: 16,
            background: "transparent",
            border: "none",
            fontSize: 24,
            cursor: "pointer",
            color: colors.textTer,
            width: 32,
            height: 32,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 4,
          }}
          onMouseEnter={(e) => {
            e.target.style.background = colors.hover;
          }}
          onMouseLeave={(e) => {
            e.target.style.background = "transparent";
          }}
        >
          ×
        </button>
      </div>
    </div>
  );
}

export default WelcomeOverlay;